//FS Bar


//Hide show the bar
let shiProgBarMain,shiElMain,elCheBtns,elTextCont,fsText;
const defineShEliBarEls = function () {
    shiProgBarMain = document.querySelector('.pn-cart-fs-bar');
    shiElMain = document.querySelector('.pn-cart-fs-eli');
    fsText = document.querySelector('.pn-cart-fs-text'); 
    fsBtn = document.querySelector('.pn-cart-fs-btn');
    elCheBtns = document.querySelectorAll('#search_postcode');
    elTextCont = document.querySelector('#shipping_rates');
}

defineShEliBarEls();

const runShElBarLogic = function () {
if(shiProgBarMain) {
function isHidden(el) {
  return window.getComputedStyle(el).display === 'none';
};

const showHideBar = function () {
    const self = this;
    setTimeout(function () {
        if(self.parentElement.parentElement.querySelector('#shipping_rates').innerText.includes('Free shipping available to your post code for') && !isHidden(self.parentElement.parentElement.querySelector('#shipping_rates'))) {
            shiProgBarMain.classList.add('rdc-active');
            shiElMain.classList.remove('rdc-active');
            localStorage.setItem('post_code_eligible', 'true');
        } else if(self.parentElement.parentElement.querySelector('.ShippingEstimator__Error').innerText.includes('Live rates available at checkout.') && !isHidden(self.parentElement.parentElement.querySelector('.ShippingEstimator__Error'))) {
            shiProgBarMain.classList.remove('rdc-active');
            shiElMain.classList.add('rdc-active');
            localStorage.setItem('post_code_eligible', 'false');
            fsText.innerHTML = '<b>Your postcode is ineligible for free shipping.</b>';
            fsBtn.innerText = 'Check another postcode.';
        };    
        // elCheBtns = document.querySelectorAll('#search_postcode');
        // shiProgBarMain = document.querySelector('.pn-cart-fs-bar');
    },2000);
};


elCheBtns.forEach(elCheBtn=> {
    elCheBtn.addEventListener('click',showHideBar);
});

const showHideBarLocal = function () {
if (localStorage.getItem('post_code_eligible') == "true") {
  shiProgBarMain.classList.add('rdc-active');
  shiElMain.classList.remove('rdc-active');
} else if (localStorage.getItem('post_code_eligible') == "false") {
  shiProgBarMain.classList.remove('rdc-active');
  shiElMain.classList.add('rdc-active');
  fsText.innerHTML = '<b>Your postcode is ineligible for free shipping.</b>';
  fsBtn.innerText = 'Check another postcode.';
};
};

if(shiProgBarMain) showHideBarLocal();



const popCl = document.querySelector('.popup-close');
const cartDr = document.querySelector('.cart-drawer__dialog');
const popOl = document.querySelector('.popup-overlay');
const chElPopup = document.getElementById('check-eligibility-popup');

const openCartManually = function () {
    const cartDrawer = document.querySelector('cart-drawer-component');
    const dialog = cartDrawer?.querySelector('dialog');

if (dialog && !dialog.open) {
  dialog.showModal();
}
};

const elCartBtn = document.querySelector('.pn-cart-el-btn');

const markElPop = function () {
    popOl.classList.add('by-cart');
    // popOl.classList.add('rdc-active');
};

if(elCartBtn) elCartBtn.addEventListener('click',markElPop);



document.addEventListener(
  'click',
  function (e) {
    if(popOl.classList.contains('by-cart')) {
    const popup = document.getElementById('check-eligibility-popup');
    if (!popup) return;

    const content = popup.querySelector('.popup-content');

    if (popup.contains(e.target) && !content.contains(e.target)) {
      openCartManually();
    }

    if (e.target.classList.contains('popup-close')) {
      openCartManually();
    }
    };
  },
  true
);

const cartObserver = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'open'
    ) {
      if (!cartDr.hasAttribute('open') && popOl.classList.contains('by-cart') && isHidden(chElPopup)) {
        popOl.classList.remove('by-cart');
      }
    }
  });
});

cartObserver.observe(cartDr, {
  attributes: true,
  attributeFilter: ['open']
});


//Bar logic
const fsThreshold = 79;

const orderTotalEl = document.querySelector('.cart__total-value');
let orderTotal;

const checkEli = function () {
    orderTotal = Number(orderTotalEl.innerText.replace('AUD',"").replace('$',""));
    const missAmt = (fsThreshold-orderTotal).toFixed(2);
    const fsBarMeas = document.querySelector('.pn-cart-fs-bar-meas-bar');
    const fsBarAmtNote = document.querySelector('.pn-cart-fs-bar-note span');
    const fsBarNote = document.querySelector('.pn-cart-fs-bar-note');
    let fsBarPerc = 100;

    if(missAmt <= 0) {
        fsBarNote.innerHTML = `Congratulations! You're eligible for <span>FREE Shipping</span>.`
    } else {
        fsBarPerc = (100-((missAmt/fsThreshold)*100)).toFixed(2);
        fsBarAmtNote.innerText = `$${missAmt}`;
    }
    fsBarMeas.style.width = `${fsBarPerc}%`;
};

if(orderTotalEl) {
  checkEli();

const observer = new MutationObserver((mutations) => {
  mutations.forEach(mutation => {
    if (mutation.type === 'childList' || mutation.type === 'characterData') {
      checkEli();
      showHideBarLocal();
    }
  });
});

observer.observe(orderTotalEl, {
  childList: true,       // detects added/removed nodes
  characterData: true,  // detects text changes
  subtree: true         // include children
});
};
};
console.log('red apr 14')
};

runShElBarLogic();

setTimeout(function () {
const atcBtn = document.querySelector('.add-to-cart-button');
// localStorage.removeItem('post_code_eligible');

if(atcBtn) {
atcBtn.addEventListener('click', function () {
    setTimeout(function () {   
    defineShEliBarEls();
    runShElBarLogic();
    },3000);
});
};
},2000);